var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAmbulantCare = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 40,
  fill: "none",
  viewBox: "0 0 54 40"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M3.46 38.624c0 .273 2.343.536 6.51.73 4.169.193 9.822.302 15.717.302 5.894 0 11.548-.109 15.716-.303 4.168-.193 6.51-.456 6.51-.73s-2.342-.535-6.51-.729-9.822-.302-15.716-.302-11.548.108-15.716.302-6.51.456-6.51.73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M51.098 24.003a24 24 0 1 0-45.862 9.9h43.726a23.9 23.9 0 0 0 2.136-9.9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M3.701 33.902h46.8M1 33.902h1.5M51.701 33.902h1.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.803,
  d: "M13.299 38.104h.357"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M49.31 35.263H8.977v-4.48h-3.92V26.8a2.02 2.02 0 0 1 1.58-1.972l2.885-.64c.375-.084.719-.273.99-.544l4.594-4.594a2.02 2.02 0 0 1 1.428-.592H49.31z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M49.31 35.263H8.977v-4.48h-3.92V26.8a2.02 2.02 0 0 1 1.58-1.972l2.885-.64c.375-.084.719-.273.99-.544l4.594-4.594a2.02 2.02 0 0 1 1.428-.592H49.31z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.56 13.945a2.645 2.645 0 0 0-2.606-2.21H21.305a3.11 3.11 0 0 0-2.948 2.125l-1.533 4.596h32.488z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M48.56 13.945a2.645 2.645 0 0 0-2.606-2.21H21.305a3.11 3.11 0 0 0-2.948 2.125l-1.533 4.596h32.488z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M49.31 33.025a1.12 1.12 0 1 1 0 2.24H12.338v-2.24z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M49.31 33.025a1.12 1.12 0 1 1 0 2.24H12.338v-2.24z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M3.379 32.462a1.68 1.68 0 0 0 1.68 1.68h3.92v-3.36h-4.48a1.12 1.12 0 0 0-1.12 1.12z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M3.379 32.462a1.68 1.68 0 0 0 1.68 1.68h3.92v-3.36h-4.48a1.12 1.12 0 0 0-1.12 1.12z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M5.109 35.326a3.92 3.92 0 1 0 7.742-1.244 3.92 3.92 0 0 0-7.742 1.244"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M5.109 35.326a3.92 3.92 0 1 0 7.742-1.244 3.92 3.92 0 0 0-7.742 1.244"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.299 34.705a1.68 1.68 0 1 0 3.359 0 1.68 1.68 0 0 0-3.36 0"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M7.299 34.705a1.68 1.68 0 1 0 3.359 0 1.68 1.68 0 0 0-3.36 0"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M36.714 35.326a3.92 3.92 0 1 0 7.742-1.244 3.92 3.92 0 0 0-7.742 1.244"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M36.714 35.326a3.92 3.92 0 1 0 7.742-1.244 3.92 3.92 0 0 0-7.742 1.244"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M38.904 34.704a1.682 1.682 0 0 0 2.87 1.188 1.683 1.683 0 0 0-.546-2.74 1.68 1.68 0 0 0-2.324 1.552"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M38.904 34.704a1.682 1.682 0 0 0 2.87 1.188 1.683 1.683 0 0 0-.546-2.74 1.68 1.68 0 0 0-2.324 1.552"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M19.62 20.7a1.12 1.12 0 0 1 1.121 1.12v1.68a1.12 1.12 0 0 1-1.12 1.12h-5.04a.927.927 0 0 1-.656-1.583l1.94-1.94c.254-.254.598-.397.957-.397z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.821 20.7c-.359 0-.703.142-.957.396l-1.94 1.94a.928.928 0 0 0 .656 1.584h.56l3.92-3.92z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M19.622 26.86h-1.12M7.298 30.782h-2.24v-2.8h1.12a1.12 1.12 0 0 1 1.12 1.12zM19.62 20.7a1.12 1.12 0 0 1 1.121 1.12v1.68a1.12 1.12 0 0 1-1.12 1.12h-5.04a.927.927 0 0 1-.656-1.583l1.94-1.94c.254-.254.598-.397.957-.397z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.115 33.026a3.9 3.9 0 0 0-7.058 0h-2.395a6.156 6.156 0 0 1 11.847 0z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M44.115 33.026a3.9 3.9 0 0 0-7.058 0h-2.395a6.156 6.156 0 0 1 11.847 0z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M47.07 25.181a2.24 2.24 0 0 0 2.24 2.24v-3.36h-2.24z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M47.07 25.181a2.24 2.24 0 0 0 2.24 2.24v-3.36h-2.24z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M47.07 18.459h2.24v2.8h-2.24z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M47.07 18.459h2.24v2.8h-2.24z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M47.07 21.26h2.24v2.8h-2.24z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M47.07 21.26h2.24v2.8h-2.24z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M28.738 23.167a.42.42 0 0 1-.124-.58l.457-.706a.42.42 0 0 1 .58-.124l1.173.759v-1.398a.42.42 0 0 1 .42-.42h.84a.42.42 0 0 1 .42.42v1.398l1.173-.76a.42.42 0 0 1 .58.125l.457.707a.42.42 0 0 1-.124.58l-1.38.892 1.38.892a.42.42 0 0 1 .124.58l-.457.707a.42.42 0 0 1-.58.124l-1.173-.759v1.397a.42.42 0 0 1-.42.42h-.84a.42.42 0 0 1-.42-.42v-1.397l-1.173.76a.42.42 0 0 1-.58-.124l-.457-.706a.42.42 0 0 1 .124-.58l1.38-.893zM17.188 33.025l1.449-1.45a1.12 1.12 0 0 0-1.585-1.585l-3.032 3.035zM30.633 33.025l1.449-1.449a1.12 1.12 0 0 0 0-1.584 1.12 1.12 0 0 0-1.585 0l-3.032 3.033zM23.91 33.025l1.448-1.45a1.12 1.12 0 0 0-1.584-1.585l-3.032 3.035z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.983 8.938a1.68 1.68 0 0 1 1.68 1.68v1.12h-3.36v-1.12a1.683 1.683 0 0 1 1.68-1.68"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M22.983 8.938a1.68 1.68 0 0 1 1.68 1.68v1.12h-3.36v-1.12a1.683 1.683 0 0 1 1.68-1.68"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M21.303 15.097a1.123 1.123 0 0 0 1.12 1.12h1.12a1.12 1.12 0 1 0 0-2.24h-1.12a1.12 1.12 0 0 0-1.12 1.12"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m21.712 15.945 2.541-1.694a1.1 1.1 0 0 0-.71-.274h-1.12a1.12 1.12 0 0 0-1.12 1.12 1.1 1.1 0 0 0 .409.848"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M21.303 15.098a1.12 1.12 0 0 0 1.12 1.12h1.12a1.12 1.12 0 1 0 0-2.24h-1.12a1.12 1.12 0 0 0-1.12 1.12"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M42.027 15.097a1.123 1.123 0 0 0 1.12 1.12h1.12a1.12 1.12 0 1 0 0-2.24h-1.12a1.12 1.12 0 0 0-1.12 1.12"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m42.437 15.945 2.54-1.694a1.1 1.1 0 0 0-.71-.274h-1.12a1.12 1.12 0 0 0-1.12 1.12 1.1 1.1 0 0 0 .41.848"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M42.027 15.098a1.12 1.12 0 0 0 1.12 1.12h1.12a1.12 1.12 0 1 0 0-2.24h-1.12a1.12 1.12 0 0 0-1.12 1.12"
})));
export { SvgAmbulantCare as ReactComponent };